module.exports = __webpack_public_path__ + "static/media/dots-bg.07429625.svg";